import { render, staticRenderFns } from "./GoliaSidebar.vue?vue&type=template&id=5e4e1a1a&scoped=true"
import script from "./GoliaSidebar.vue?vue&type=script&lang=js"
export * from "./GoliaSidebar.vue?vue&type=script&lang=js"
import style0 from "./GoliaSidebar.vue?vue&type=style&index=0&id=5e4e1a1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e4e1a1a",
  null
  
)

export default component.exports